import { render, staticRenderFns } from "./NewPermPlacement.vue?vue&type=template&id=22a75354&scoped=true&"
import script from "./NewPermPlacement.vue?vue&type=script&lang=js&"
export * from "./NewPermPlacement.vue?vue&type=script&lang=js&"
import style0 from "./NewPermPlacement.vue?vue&type=style&index=0&id=22a75354&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a75354",
  null
  
)

export default component.exports